import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../_metronic/layout/core';
import { registerLocale } from 'react-datepicker';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import AgTable from '../../../Components/Table/AgTable';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function FlashSemanal({ title }) {

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [date1, setDate1] = useState(new Date(year, month, 1));

    const [date2, setDate2] = useState(new Date());

    const [dateRange, setDateRange] = useState([date1, date2]);
    const [startDate, endDate] = dateRange;

    registerLocale('es', es);


    let header = [
        {
            headerName: 'Unidad',
            field: 'unidad',
        },
        {
            headerName: 'Mall',
            field: 'mall',
        },
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Den Cont',
            field: 'denCont',
        },
        {
            headerName: 'Objetos',
            field: 'objetos',
        },
        {
            headerComponent: () => (<span>Area (m<sup>2</sup>)</span>),
            accessor: 'area',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.area, true, 4)}</>
            )
        },
        {
            headerName: 'Cod-Cebe',
            field: 'codCebe',
        },
        {
            headerName: 'CEBE',
            field: 'cebe',
        },
        {
            headerName: 'Cod-Rubro',
            field: 'codRubro',
        },
        {
            headerName: 'Rubro',
            field: 'rubro',
        },
        {
            headerName: 'Comercial',
            field: 'comercial',
        },
        {
            headerName: 'Año Actual',
            field: 'montoAnioActual',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.montoAnioActual, true)}</>
            )
        },
        {
            headerName: 'Año Pasado',
            field: 'montoAnioPasado',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.montoAnioPasado, true)}</>
            )
        },
        {
            headerName: 'Dif (S/)',
            field: 'difMonto',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.difMonto, false)}</>
            )
        },
        {
            headerName: 'Dif (%)',
            field: 'difPorcentaje',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.difPorcentaje)}</>
            )
        }
    ];

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const getOptionValueUnidEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
    }

    const [codigoContrato, setCodigoContrato] = useState(null);

    const [value, onChange] = useState([new Date(year, month, 1), new Date()]);

    function handleChangeCodigoContrato(event) {
        if (event.key === 'Enter') {
            setCodigoContrato(event.target.value);
        }
    }


    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.REPORTE_PROYECCIÓN]} >
                <PageTitle>{title}</PageTitle>
                <div className="card my-5">
                    <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">
                            <div className="col-12 col-sm-3 col-md-4">
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                <Select
                                    classNamePrefix='filter'
                                    components={animatedComponents}
                                    defaultValue={getOptionValueUnidEconomica(unidadesEconomicasList.defaultId)}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    options={unidadesEconomicasList.list}
                                    onChange={(onChangeUnidadEconomica)}
                                />
                            </div>

                            <div className='col-12 col-sm-6 col-md-5'>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Rango de Fecha:</div>
                                <DateRangePicker
                                    onChange={(dateRange) => {
                                        onChange(dateRange)
                                        dateRange &&
                                            setDateRange(dateRange);
                                    }}
                                    value={value}
                                    format="dd/MM/y"
                                    className="form-control form-control-transparent fit-content-width"
                                    locale="es"
                                />
                            </div>

                            <div className="col-12 col-sm-3 col-md-3">
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Código Contrato:</div>
                                <input type="text" name="name" className="form-control"
                                    onKeyDown={handleChangeCodigoContrato} />
                            </div>
                    </div>

                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"Flash Semanal " + unidadEconomica.value + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "") + codigoContrato}
                            apiService={Api.FlashSemanal}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Flash Semanal " + unidadEconomica.label + " " + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "") + " " + codigoContrato}
                            conditions={dateRange[0] != null && dateRange[1] != null}
                            args={{ fechaInicio: dateRange[0] && Utilities.formaterDate(dateRange[0]), fechaFin: dateRange[1] && Utilities.formaterDate(dateRange[1]), unidadEconomicaId: unidadEconomica.value, codigoContratoId: codigoContrato, token: useGetToken() }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            useFlex={false}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}